import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Edit from '@material-ui/icons/Edit'
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import PriorityHigh from '@material-ui/icons/PriorityHigh'
import CheckBox from '@material-ui/icons/CheckBox'
import Select from "react-select";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import {isEmptyObject} from "jquery";
import {confirmAlert} from "react-confirm-alert";

const dateRangeProperties = {
	startDate: {
		error: '',
		fill: true,
		helper: '',
		label: 'Start Date',
		name: 'startDate',
		override: null,
		queryable: false,
		required: false,
		searchable: true,
	},
	endDate: {
		error: '',
		fill: true,
		helper: '',
		label: 'End Date',
		name: 'endDate',
		override: null,
		queryable: false,
		required: false,
		searchable: true,
	}
};

const dateValueRegex = /\d\d\d\d-\d\d-\d\d\s\d\d:\d\d:\d\d/;

export default class CashCheckFinancials extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = "GET_CASH_CHECK";
		this.state.limit = 16;
		let requests = JSON.parse(localStorage.getItem('table-preferences-CashCheckFinancials'));
		if (isEmptyObject(requests)) {
			requests = {default: {startDate: null, endDate: null}}
		}
		requests.default.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD') + ' 00:00:00';
		requests.default.endDate = moment().format('YYYY-MM-DD') + ' 00:00:00';
		localStorage.setItem('table-preferences-CashCheckFinancials', JSON.stringify(requests));
		this.state = {
			...this.state,
			selectedUsers: [],
			selectedUser: null,
			users: [],
			selectedPaymentType: null,
			total: 0,
			initialDate: [{'start': moment().subtract(7, 'days').format('YYYY-MM-DD') + ' 00:00:00', 'end': moment().format('YYYY-MM-DD') + ' 00:00:00'}],
			startDate: moment().subtract(7, 'days').format('YYYY-MM-DD') + ' 00:00:00',
			endDate: moment().format('YYYY-MM-DD') + ' 00:00:00',
			paymentTypes: []
		}

	}

	async componentDidMount() {
		await this.getUsers();
		await this.getPaymentTypes();
		//this modifies the tableheaderright's flexgrow
		$('.TableHeaderRight').css('flex-grow', '0');
	}


	fetchData = async (state) => {
		this.state.limit = 15;
		if (typeof(this.state.filter) === "undefined") {
			this.state.filter = {};
		}
		this.state.filter.selectedUser = this.state.selectedUser?.value ?? null;
		this.state.filter.selectedPaymentType = this.state.selectedPaymentType?.value ?? null;
		this.state.filter.date = this.state.initialDate ?? [{'start': this.state.startDate, 'end': this.state.endDate}]
		this.setState({loading: true});
		window.setTimeout(() => {
			this.fetchDataActual(state, ['total']);
		}, 100);
	}


	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		userModel.limit = 50;
		userModel.filter = {'inactive': true}
		try {
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	getPaymentTypes = async () => {
		let ptypesModel = new API.BuildClass(Types.Tickets_Financials_Types._name, API.RequestType.READ_ALL);
		try {
			this.paymentTypes = await ptypesModel.submit(null, API.RequestType.READ_ALL);
			this.paymentTypes = Object.keys(this.paymentTypes).map((key) => this.paymentTypes[key]);
			this.paymentTypes = this.paymentTypes[3];
			this.paymentTypes = this.paymentTypes.filter((item) => {return [1, 2].includes(item.pkey)})

			this.setState({
				paymentTypes: this.paymentTypes
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleUsers = async (value) => {
		await this.setState({selectedUser: value, field_engineers: []})
		await this.fetchData();
	}


	handlePaymentTypes = async (value) => {
		await this.setState({selectedPaymentType: value})
		await this.fetchData();
	}


	handleDateChange = (property, value) => {
		let {startDate, endDate} = this.state;
		let _startDate = moment(startDate);
		let _endDate = moment(endDate);
		let _value = moment(value);
		if (property === 'startDate') {
			if (_value.isAfter(_endDate)) {
				alert('Start date may not be after end date.')
				return;
			}
			startDate = value?value.split(' ')[0]:null;
			if (startDate) {
				startDate += ' 00:00:00';
			}
			if(endDate !== null){
				endDate = endDate.split(' ')[0];
				if (endDate) {
					endDate += ' 23:59:59';
				}
			}
		}
		if (property === 'endDate') {
			if (_value.isBefore(_startDate)) {
				alert('End date may not be before start date.')
				return;
			}
			endDate = value?value.split(' ')[0]:null;
			if (endDate) {
				endDate += ' 23:59:59';
			}
			if(startDate !== null){
				startDate = startDate.split(' ')[0];
				if (startDate) {
					startDate += ' 00:00:00';
				}
			}
		}
		this.state.initialDate = null;
		this.handleTextFieldPropertyUpdate(property, value);
		let values = [
			{
				value: {
					start: startDate,
					end: endDate,
				}
			}
		];		// Only send filter request if dates are valid
		if ((!startDate || startDate.match(dateValueRegex)) && (!endDate || endDate.match(dateValueRegex))) {
			this.doFilter(values, {name: 'date'});
		} else {
			this.doFilter([], {name: 'date'});
		}
	}

	approve = (e) => {
		const pkey = parseInt(e.currentTarget.id);
		const ticket = e.currentTarget.getAttribute('ticket');

		confirmAlert({
			title: 'Confirm Approval',
			message: 'Are you sure you want to approve ticket #' + ticket + ' financially?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.UPDATE);
						this.update = 'POST_APPROVE_HELPDESK';
						model.object.pkey = pkey;

						try {
							await model.submit(null, this.update);
						} catch (error) {
						}

						await this.fetchData()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handleDeposited = async (pkey, fdticket, ticket) => {
		confirmAlert({
			title: 'Confirm Approval',
			message: 'Are you sure you want to confirm that the payment for ticket #' + fdticket + ' was deposited?',
			buttons: [
				{
					label: 'Yes',
					color: 'danger',
					onClick: async () => {
						let model = new API.BuildClass(Types.Tickets_Financials._name, API.RequestType.UPDATE);
						this.update = 'POST_DEPOSIT_HELPDESK';
						model.object.pkey = pkey;
						model.object.parent = ticket;

						try {
							await model.submit(null, this.update);
						} catch (error) {
						}
						await this.fetchData()
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	render() {
		const {data, pages, limit, loading,} = this.state;

		const columns = [
			{
				Header: "FD Ticket",
				id: "tickets.fresh_ticket",
				width: 100,
				accessor: obj => freshdeskTicketExport(obj.tickets?.fresh_ticket),
				Cell: props => <FreshdeskTicketLink freshTicket={props.original.tickets?.fresh_ticket} />
			},
			{
				Header: "Date",
				id: 'created',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.created ? moment(obj.created).local().format('MM/DD/YYYY h:mm A') : '',
			},
			{
				Header: "Customer",
				id: 'tickets.customers.name',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets.customers.name,
				Cell: (props) => {
					return <Link to={`/tickets/${props.original.ticket}`}>
						{props.original.tickets.customers.name}
					</Link>
				}
			},
			{
				Header: "Field Engineer",
				id: 'tickets.field_engineer',
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets.users.name_first + " " + obj.tickets.users.name_last,
			},
			{
				Header: "P. Type",
				id: 'tickets_financials_types.name',
				width: 80,
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.tickets_financials_types?.name,
			},
			{
				Header: "Total",
				id: 'totaled_amount',
				width: 80,
				/** @param {Tickets_Financials_Object} obj */
				accessor: obj => obj.totaled_amount,
			},
			{
				Header: "Deposited",
				id: "deposited",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.deposited}
								onChange={async () => {
									await this.handleDeposited(props.original.pkey, props.original.tickets.fresh_ticket, props.original.tickets.pkey)
								}}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Reviewed By",
				id: 'userChecked',
				accessor: obj => (obj.approved_helpdesk_user_name)
			},
			{
				Header: "Reviewed At",
				id: 'reviewed_at',
				accessor: obj => obj.approved_helpdesk_timestamp ? moment(obj.approved_helpdesk_timestamp).format('MM/DD h:m A') : '',
			},
			{
				Header: "Approve",
				className: "button-cell d-flex justify-content-center",
				filterable: false,
				sortable: false,
				width: 100,
				Cell: props => {
					return (
						<span>
							{props.original.approved_helpdesk === false ?
								<Button id={props.original.pkey} ticket={props.original.ticket} color="secondary" size={"sm"} onClick={this.approve}>
									<PriorityHigh fontSize={'small'}/></Button>
								:	<Link to={"/financial/" + props.original.pkey}> <Button color="primary" size={"sm"}> <CheckBox fontSize={'small'}/></Button></Link>
							}
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Link to={"/financial/" + props.original.ticket}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<Edit fontSize={'small'}/></Button>
							</Link>
						</span>
					);
				}
			},

		]

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Financials')}
							<div className="row dateRangeSearch">
								<div className="col">
									<Paper>
										<Framework.Elements.Date
											label="Start Date"
											property={dateRangeProperties.startDate}
											value={this.state.startDate}
											update={this.handleDateChange}
											disabled={false}
										/>
									</Paper>
								</div>
								<div className="col">
									<Paper>
										<Framework.Elements.Date
											label="End Date"
											property={dateRangeProperties.endDate}
											value={this.state.endDate}
											update={this.handleDateChange}
											disabled={false}
										/>
									</Paper>
								</div>
							</div>
							<div style={{flexGrow: 1}}>
								<Select
									key={this.state.users}
									placeholder={"User Select"}
									isMulti={false}
									isClearable={true}
									value={this.state.selectedUser}
									onChange={this.handleUsers}
									options={this.state.users.map(user => {
										return (
											{value: user.pkey, label: user.name_first + " " + user.name_last})
									})}
								/>
							</div>
							<div style={{flexGrow: 1}}>
								<Select
									key={this.state.paymentTypes}
									placeholder={"Payment Type"}
									isMulti={false}
									isClearable={true}
									value={this.state.selectedPaymentType}
									onChange={this.handlePaymentTypes}
									options={this.state.paymentTypes.map(ptype => {
										return (
											{value: ptype.pkey, label: ptype.name})
									})}
								/>
							</div>
							{this.state.total > 0 && <div style={{marginLeft: 15}}>
								Grand Total: <br/> ${this.state.total}
							</div>}
							{this.renderHeaderRight("Financials", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
